// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__Thwka","container_video":"styles_container_video__iUcwl","video":"styles_video__-1z2f","container_content":"styles_container_content__StUJq"};